import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Mail, LayoutDashboard } from 'lucide-react';

const SeriesFooter = ({ series }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-400 py-16">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: series.accentColor }}
              >
                <BookOpen className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="font-bold text-white text-lg">30 Day Skills</span>
                <span className="text-slate-500 text-sm block -mt-1">{series.name} Series</span>
              </div>
            </div>
            <p className="text-slate-500 max-w-md leading-relaxed">
              Transform from technical expert to confident IT leader in just 30 days with practical, actionable lessons.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#journey" 
                  className="hover:text-white transition-colors"
                  style={{ '--hover-color': series.accentColor }}
                >
                  Journey Preview
                </a>
              </li>
              <li>
                <a 
                  href="#series" 
                  className="hover:text-white transition-colors"
                >
                  Book Series
                </a>
              </li>
              <li>
                <a 
                  href="#author" 
                  className="hover:text-white transition-colors"
                >
                  About the Author
                </a>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-white font-semibold mb-4">Account</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/login" 
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  <LayoutDashboard className="w-4 h-4" />
                  My Dashboard
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:coach@30dayskills.co.uk"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  AI Companion
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {currentYear} {series.author.name}. All rights reserved. A 30 Day Skills publication.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-sale" className="hover:text-white transition-colors">Terms of Sale</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SeriesFooter;
